import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Rascunho da tela Site (admin) para a pré-visualização ao vivo: a página aberta com ?previa=1 dentro da tela Site
 *  mostra o que está sendo digitado, antes de salvar. Fora disso, nada muda. */
export const CHAVE_PREVIA = "iep-site-previa";
const emPrevia = () => { try { return new URLSearchParams(window.location.search).get("previa") === "1" && window.parent !== window; } catch { return false; } };
const lerPrevia = () => { try { return JSON.parse(localStorage.getItem(CHAVE_PREVIA) || "null"); } catch { return null; } };

/** Configuração pública do site (textos da entrada, /cursos, /sobre, depoimentos...). null enquanto carrega. */
export function useSite() {
  const [site, setSite] = useState(null);
  useEffect(() => {
    let vivo = true;
    api.get("/site").then((r) => vivo && setSite({ ...r.data, ...(emPrevia() ? lerPrevia() || {} : {}) })).catch(() => vivo && setSite({}));
    if (!emPrevia()) return () => { vivo = false; };
    const ouvir = (e) => { if (e.key === CHAVE_PREVIA) { const p = lerPrevia(); if (p) setSite((s) => ({ ...(s || {}), ...p })); } };
    window.addEventListener("storage", ouvir);
    return () => { vivo = false; window.removeEventListener("storage", ouvir); };
  }, []);
  return site;
}

/** Textos padrão da tela de entrada (o admin pode trocar cada um na tela Site → Tela de entrada). */
export const LOGIN_PADRAO = {
  kicker: "CIÊNCIA • FORMULAÇÃO • GESTÃO • RESULTADO",
  titulo: "A plataforma oficial do Cabeleireiro Científico Formulador",
  subtitulo: "Tudo o que você precisa para estudar, formular e crescer.",
  itens: ["Aulas do Método no celular ou no computador", "Fórmulas e fichas técnicas para levar ao salão", "IEP INTELLIGENCE: sua assistente científica",
    "IEP Salão: agenda, clientes e caixa", "Certificado com validação online"],
  cartao_titulo: "Entrar na plataforma",
  cartao_sub: "Que bom ter você de volta!",
  faixa: ["Manipulação|Profissional", "Cosmética|Científica", "Formação|Avançada", "Gestão do|Salão", "Rede de|Credenciadas"],
};
export const loginTextos = (site) => {
  const l = site?.login || {};
  const lista = (v, p) => (Array.isArray(v) && v.some((x) => (x || "").trim()) ? p.map((x, i) => ((v[i] || "").trim() ? v[i] : x)) : p);
  return { ...LOGIN_PADRAO, ...Object.fromEntries(Object.entries(l).filter(([k, v]) => typeof v === "string" && v.trim())),
    itens: lista(l.itens, LOGIN_PADRAO.itens), faixa: lista(l.faixa, LOGIN_PADRAO.faixa) };
};
